// Translation object
export const islandsTranslations = {
  it: {
    pageTitle: "Riserve della Biosfera",
    loading: "Caricamento Aree naturalistiche e isole...",
    loadingFromServer: "Non sono presenti informazioni sulle aree naturalistiche in memoria - scaricamento dal server",
    errorMessage: "Problema nella ricezione dei dati sulle aree naturalistiche",
    cardContent: "Le Riserve della Biosfera sono sono aree riconosciute dal Programma MAB (Man and Biosphere) dell'UNESCO dove natura e comunità convivono in armonia. Lungo il fiume Po si promuove un equilibrio tra le esigenze economiche, sociali e ambientali, a partire dalla conoscenza del fiume e dal valore identitario dei suoi territori rivieraschi, con uno sguardo rivolto alle future generazioni.",
    mapButtonText: "Guarda le aree naturalistiche nella riserva MAB UNESCO e l'elenco dei musei del Po sulla mappa",
    errorHeader: "Errore di recupero dati",
    errorAlert: "C'è stato un problema nel recupero dei dati sulle aree naturalistiche e le isole! Per favore riavvia l'app e riprova.",
    okButton: "Ok"
  },
  en: {
    pageTitle: "Biosphere Reserves",
    loading: "Loading natural areas and islands...",
    loadingFromServer: "No information about natural areas in memory - downloading from server",
    errorMessage: "Problem receiving data about natural areas",
    cardContent: "Biosphere Reserves are areas recognized by UNESCO's MAB (Man and Biosphere) Program where nature and communities coexist in harmony. Along the Po River, a balance between economic, social and environmental needs is promoted, starting from the knowledge of the river and the identity value of its riverside territories, with a look towards future generations.",
    mapButtonText: "View natural areas in the MAB UNESCO reserve and the list of Po museums on the map",
    errorHeader: "Data Retrieval Error",
    errorAlert: "There was a problem retrieving data about natural areas and islands! Please restart the app and try again.",
    okButton: "Ok"
  }
};